module.exports = "/_layouts/15/Sites/Families/React/wp/images/Date.png";